/**
 * 到达节点类型（接口传参，前端筛选用）：0-仓库(whs)，1-枢纽(hub)
 */
export const ARRIVAL_POINT_TYPE_WHS = 0;
export const ARRIVAL_POINT_TYPE_HUB = 1;
export type ArrivalPointType = typeof ARRIVAL_POINT_TYPE_WHS | typeof ARRIVAL_POINT_TYPE_HUB;

/**
 * 客户时区：0-本地(仓库时区)，1-美西
 */
export const TIMEZONE_LOCAL = 0;
export const TIMEZONE_WEST_US = 1;
export type SlaTimezone = typeof TIMEZONE_LOCAL | typeof TIMEZONE_WEST_US;

/**
 * 维度类型（与后端 DimensionType 一致）：area-区域，driver-司机，dsp-DSP，whs-仓库
 */
export const DIMENSION_AREA = 'area' as const;
export const DIMENSION_DRIVER = 'driver' as const;
export const DIMENSION_DSP = 'dsp' as const;
export const DIMENSION_WHS = 'whs' as const;
export type SlaDimensionType = typeof DIMENSION_AREA | typeof DIMENSION_DRIVER | typeof DIMENSION_DSP | typeof DIMENSION_WHS;
